module.exports = __webpack_public_path__ + "assets/images/03-balloon_2851997bcfbda2d6005d6b00a63511dd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/avatars/03-balloon.png
// module id = 174
// module chunks = 0